/* MYNTELO v7 hero carousel (A.3, 2026-11-02), sections/myntelo-v7-hero.liquid: 6 s autoplay, paused on hover, focus, hidden tab,
   pause button and reduced motion; bars, arrows, swipe. data-myn-hero-tone follows the active slide (for the header).
   Slides 2+ ship their image as data-src / data-srcset: slide 2 is filled in after window load (idle or 1 s), every other slide just
   before it shows, and the one after it as soon as it shows. */
(function () {
  'use strict';
  var DUR = 6000;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root._myn) return;
    var slides = [].slice.call(root.querySelectorAll('[data-myn-slide]'));
    var bars = [].slice.call(root.querySelectorAll('[data-myn-bar]'));
    var n = slides.length;
    if (n < 2) return;
    root._myn = true;
    var live = root.querySelector('[data-myn-live]');
    var pauseBtn = root.querySelector('[data-myn-pause]');
    var track = root.querySelector('[data-myn-track]');
    var i = 0, timer = 0, hover = false, focus = false, stopped = reduce;

    function hydrate(s) {
      if (!s || s._mynH) return;
      s._mynH = true;
      [].forEach.call(s.querySelectorAll('[data-srcset], [data-src]'), function (el) {
        if (el.loading === 'lazy') el.loading = 'eager';
        if (el.hasAttribute('data-srcset')) { el.srcset = el.getAttribute('data-srcset'); el.removeAttribute('data-srcset'); }
        if (el.hasAttribute('data-src')) { el.src = el.getAttribute('data-src'); el.removeAttribute('data-src'); }
      });
    }
    function line(s) { var l = s.querySelector('.myn-hero__line'); return l ? l.textContent : ''; }
    function show(k, user) {
      k = (k + n) % n;
      if (k !== i) {
        var a = slides[i], b = slides[k];
        a.classList.remove('is-active'); a.setAttribute('aria-hidden', 'true'); a.inert = true;
        bars[i].classList.remove('is-active'); bars[i].removeAttribute('aria-current');
        hydrate(b);
        b.classList.add('is-active'); b.removeAttribute('aria-hidden'); b.inert = false;
        bars[k].classList.add('is-active'); bars[k].setAttribute('aria-current', 'true');
        i = k;
        root.setAttribute('data-myn-hero-tone', b.getAttribute('data-myn-tone') || (b.classList.contains('myn-hero__slide--render') ? 'light' : 'dark'));
        if (user && live) live.textContent = b.getAttribute('aria-label') + '. ' + line(b);
        hydrate(slides[(k + 1) % n]);
      }
      play();
    }
    function play() {
      clearTimeout(timer);
      root.classList.remove('is-playing');
      if (stopped || hover || focus || document.hidden) return;
      void root.offsetWidth;
      root.classList.add('is-playing');
      timer = setTimeout(function () { show(i + 1, false); }, DUR);
    }

    bars.forEach(function (bar, k) { bar.addEventListener('click', function () { show(k, true); }); });
    if (pauseBtn) {
      if (reduce) { pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play'); }
      pauseBtn.addEventListener('click', function () {
        stopped = !stopped;
        pauseBtn.setAttribute('aria-pressed', String(stopped));
        pauseBtn.setAttribute('aria-label', stopped ? 'Play' : 'Pause');
        if (!stopped) focus = false;
        play();
      });
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        show(i + (e.key === 'ArrowRight' ? 1 : -1), true);
        var f = document.activeElement;
        if (f && f.hasAttribute && f.hasAttribute('data-myn-bar')) bars[i].focus();
      }
    });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; play(); } });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; play(); } });
    root.addEventListener('focusin', function (e) { if (e.target !== pauseBtn) { focus = true; play(); } });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focus = false; play(); } });
    document.addEventListener('visibilitychange', play);

    var x0 = null, y0 = 0, swiped = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; swiped = false; });
    track.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(i + (dx < 0 ? 1 : -1), true); }
    });
    track.addEventListener('pointercancel', function () { x0 = null; });
    track.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); swiped = false; } }, true);

    root._mynShow = function (k) { show(k, false); };
    function warm() {
      var go = function () { hydrate(slides[1]); };
      if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 1000 }); else setTimeout(go, 1000);
    }
    if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });
    play();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-myn-hero]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest && e.target.closest('[data-myn-hero]');
    if (s && s._mynShow) s._mynShow([].indexOf.call(s.querySelectorAll('[data-myn-slide]'), e.target));
  });
})();
